document.addEventListener('cmplz_fire_categories', function(event) {
    var categories = event.detail.categories;
    if (!categories.includes('marketing')) {
      if (!jQuery('#rolex-contact-map').hasClass('placeholder')) {
        var infosText = jQuery('#rolex-contact-map').data('infos-text');
        var btnText = jQuery('#rolex-contact-map').data('btn-text');
        jQuery('#rolex-contact-map').addClass('placeholder');
        jQuery('#rolex-contact-map').append(`
          <div class="placeholder-action">
            <p>${infosText}</p>
            <button id="open-cookie-banner" class="btn-primary">${btnText}</button>
          </div>
        `);
        jQuery('#open-cookie-banner').on('click', function() {
          cmplz_set_consent('marketing', 'allow');
        });
      }
    }
  });